import { jwtDecode } from "jwt-decode";
import {
  type JwtViewAction,
  type AccessToken,
  type JwtViewActionName,
} from "~/api/generated/model";

export type DiJwtTokenPayload = AccessToken;

// Docs: https://www.rfc-editor.org/rfc/rfc7519#section-2
export type NumericDate = number; // seconds since Epoch

// TODO: When the API exposes an enum for this, use it.
export type DiJwtPermission = string;

export type DiJwtLimitedScope = JwtViewActionName;

export type DiJwtRequiredAction = JwtViewAction;

export const extractDiJwtPayload = (
  token: string | null | undefined,
): DiJwtTokenPayload | null =>
  token ? jwtDecode<DiJwtTokenPayload>(token) : null;
